import React, { useEffect } from 'react';
import { IModule } from '../../core/api/types/IModule';
import { useHistory } from 'react-router-dom';
import { flatModuleOptions } from 'core/api/helpers/flatModuleOptions';

type IModuleWithSettings = { TrackingId: string } & IModule;

const GoogleAnalytics = (props: IModuleWithSettings) => {
  const module = flatModuleOptions<IModuleWithSettings>(props.module as any);

  const history = useHistory();

  useEffect(() => {
    const srcScriptId = 'ga-module';
    const inlineScriptId = 'ga-module-config';

    const gaModule = window.document.getElementById(srcScriptId) as HTMLScriptElement;
    if (gaModule && isEnabled()) {
      gaModule.src = `https://www.googletagmanager.com/gtag/js?id=${module.TrackingId}`;
    }

    const inlineScript = window.document.getElementById(inlineScriptId) as HTMLScriptElement;
    const userId = localStorage.getItem('user.id');
    if (inlineScript && isEnabled()) {
      inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${module.TrackingId}', { user_id: '${userId}'});
      `;
    }
  }, []);

  useEffect(() => {
    pageView(window.location.href);
  }, [history]);

  const pageView = (path: string) => {
    if (!isEnabled()) {
      return;
    }
    //@ts-ignore
    gtag('event', 'page_view', { page_location: path });
  };

  const isEnabled = () => {
    let trackingId = module.TrackingId;
    return !!trackingId && trackingId !== '';
  };

  return <></>;
};

export default GoogleAnalytics;
